//
//
//
//
//
//
//
//
//
//
//
//
//
//
import LinksNewsletter from './LinksNewsletter/LinksNewsletter.vue';
import PaymentSocials from './PaymentSocials/PaymentSocials.vue';
import MentionsLanguage from './MentionsLanguage/MentionsLanguage.vue';
import Reinsurance from './Reinsurance/Reinsurance.vue';
import footerQuery from '~/graphql/footer.gql';
export default {
  name: 'TheFooter',
  serverCacheKey: function serverCacheKey(props) {
    return "\n    ".concat(props.locale.market, "\n    _\n    ").concat(props.locale.language, "\n  ");
  },
  components: {
    LinksNewsletter: LinksNewsletter,
    PaymentSocials: PaymentSocials,
    MentionsLanguage: MentionsLanguage,
    Reinsurance: Reinsurance
  },
  props: {
    locale: {
      type: Object,
      default: function _default() {
        return {
          market: '',
          language: ''
        };
      }
    }
  },
  apollo: {
    footer: {
      query: footerQuery,
      variables: function variables() {
        return {
          locale: this.locale.iso
        };
      }
    }
  }
};